import { colors, fonts } from '../theme'

export default function SectionBar({ title, subtitle, accent = 'steel' }) {
  const accentColor = accent === 'gold' ? colors.gold : colors.steel

  return (
    <div style={{ ...styles.bar, borderLeftColor: accentColor }}>
      <span style={{ ...styles.title, color: accentColor }}>{title}</span>
      {subtitle && <span style={styles.subtitle}>{subtitle}</span>}
    </div>
  )
}

const styles = {
  bar: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 12,
    padding: '8px 16px',
    borderLeft: '3px solid',
    marginBottom: 12,
  },
  title: {
    fontFamily: fonts.serif,
    fontSize: 15,
    fontWeight: 600,
    textTransform: 'uppercase',
    letterSpacing: 0.5,
  },
  subtitle: {
    fontFamily: fonts.serif,
    fontSize: 12,
    fontStyle: 'italic',
    color: colors.textMuted,
  },
}
